export default __webpack_public_path__ + "static/media/AssetLocationIcon.955710d4.svg";